module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/take-assignment/take-assignment.component.css
// module id = ./src/app/assessments/take-assignment/take-assignment.component.css
// module chunks = main